export function getManualTestTodoDisplayTitle({
  testKeyRef,
  testTitle,
  manualTestName = '',
} = {}) {
  const displayTitle = `${testKeyRef} - ${testTitle}`;

  return manualTestName ? `${displayTitle} (${manualTestName})` : displayTitle;
}
